import React, { useEffect } from 'react';
import { i18nFn, useAuthPin, useSpringBigStore } from '@springbig/shared';
import { HStack, Pressable, VStack } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import { useGeneralStyles } from '~/shared/styles';
import { useAppNavigate } from '~/pages';

type BirthdayStepProps = {
    t: i18nFn;
    onEvent: (message: string) => void;
};

export const BirthdayStep = ({
    t,
    onEvent,
}: BirthdayStepProps) => {

    const { navigate, params } = useAppNavigate();
    const gStyle = useGeneralStyles();
    const { birthdays } = useSpringBigStore();

    const { mutate: authPin, error, isError } = useAuthPin();

    const submitBirthday = (birthday: string): void => {

        authPin({
            birthday,
            stashboardOrMemberKey: params.wallet_id,
        }, {
            onSuccess: (response) => {

                if (response.step) {
                    onEvent(response.step);
                }
            }
        });
    };

    useEffect(() => {

        if (!birthdays) {
            navigate(`w/${params.wallet_id}/`);
        }
    }, [birthdays]);

    return (
        birthdays && birthdays.length > 0 ?

            <VStack space={8} w={'100%'} alignItems={'center'}>
                <VStack>
                    <H3 fontSize={20}>
                        { t('auth.ten_dlc.birthday.title') }
                    </H3>
                    <Caption maxW={'100%'}>
                        { t('auth.ten_dlc.birthday.description') }
                    </Caption>
                </VStack>
                { isError &&
                    <Caption
                        fontSize={12}
                        color={gStyle.button_danger_background}
                        textAlign={'center'}
                    >
                        { (error?.data?.error) as any }
                    </Caption>
                }
                <VStack space={4}>
                    <HStack
                        space={4}
                        flexWrap={'wrap'}
                    >
                        { birthdays.slice(0, 2).map((birthday, index) =>

                            <Pressable
                                key={index}
                                onPress={() => submitBirthday(birthday)}
                                bg={gStyle.button_background}
                                px={4}
                                py={2}
                                flex={1}
                                rounded={'md'}
                            >
                                <Caption
                                    color={gStyle.button_text}
                                    fontSize={18}
                                    fontWeight={300}
                                    w={'110px'}
                                    textAlign={'center'}
                                >
                                    { birthday }
                                </Caption>
                            </Pressable>
                        )}
                    </HStack>
                    <HStack
                        space={4}
                        flexWrap={'wrap'}
                    >
                        { birthdays.slice(2, 4).map((birthday, index) =>

                            <Pressable
                                key={index}
                                onPress={() => submitBirthday(birthday)}
                                bg={gStyle.button_background}
                                px={4}
                                py={2}
                                flex={1}
                                rounded={'md'}
                            >
                                <Caption
                                    color={gStyle.button_text}
                                    fontSize={18}
                                    fontWeight={300}
                                    w={'110px'}
                                    textAlign={'center'}
                                >
                                    { birthday }
                                </Caption>
                            </Pressable>
                        )}
                    </HStack>
                </VStack>
            </VStack>
            :
            <Caption>An error occurred, could not fetch birthday from database</Caption>
    );
};
